import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { DeviceGroup } from './../../../api/models/device-group.model';

export const scenesAdapter: EntityAdapter<DeviceGroup> = createEntityAdapter<DeviceGroup>({
    selectId: (scene: DeviceGroup) => scene.Id
});


export interface SceneState extends EntityState<DeviceGroup> {
    ids: number[];
    entities: any;
    total: number;
    loaded: boolean;
    newlyCreatedScene: DeviceGroup;
}



